import { common, orderStatus, modalTalkToProducer } from 'locales';

export type LangKeys = 'pt' | 'en' | 'es';

function selectLang(lang: LangKeys): LangKeys {
  const langs = {
    pt: 'pt',
    en: 'en',
    es: 'es'
  };

  return (langs[lang] as LangKeys) || 'pt';
}

export function useTranslations() {
  let queryLang: LangKeys = selectLang('pt');
  queryLang = queryLang.toLowerCase() as LangKeys;

  const translations = {
    locale: queryLang,
    common: common[queryLang],
    orderStatus: orderStatus[queryLang],
    modalTalkToProducer: modalTalkToProducer[queryLang]
  };

  return translations;
}
